var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 ",class:[_vm.skinClasses],attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath})],1),(_vm.showQuoteLog)?_c('quote-log-panel'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }